var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.1713 2.00002L9.838 3.33336H3.33333V12.6667H12.6667V6.16202L14 4.82869V13.3334C14 13.5102 13.9298 13.6797 13.8047 13.8048C13.6797 13.9298 13.5101 14 13.3333 14H2.66667C2.48986 14 2.32029 13.9298 2.19526 13.8048C2.07024 13.6797 2 13.5102 2 13.3334V2.66669C2 2.48988 2.07024 2.32031 2.19526 2.19529C2.32029 2.07026 2.48986 2.00002 2.66667 2.00002H11.1713ZM13.6567 1.40002L14.6 2.34402L8.472 8.47202L7.53067 8.47402L7.52933 7.52936L13.6567 1.40002Z",
    fill: "#B45436"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.6dd6a407ceebae726d94b4963fbb2bc1.svg";
export { ForwardRef as ReactComponent };